// Vendors
import './scss/vendor/owl.carousel.min.css'

// Theme Sass.
import './scss/main.scss';

// Theme JavaScript.
import './js/main';